export class StringUtils {
    static sanitize(str) {
        return str
            .normalize('NFD') // Normalize to decomposed form
            .replace(/[\u0300-\u036f]/g, '') // Remove diacritics
            .replace(/[^a-zA-Z0-9-_]/g, '-') // Replace non-alphanumeric characters with hyphens
            .replace(/^-+|-+$/g, '') // Remove leading and trailing hyphens
            .replace(/-{2,}/g, '-'); // Replace multiple hyphens with a single hyphen
    }
    static formatNumber(number) {
        return number.toLocaleString(navigator.language, {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
        });
    }
}
